module.exports = __webpack_public_path__ + "img/arrow-left.dd34b8be.svg";